<template>
  <fragment>
    <ribbon v-if="trsMode" :text="content.trs_pv_package_ribbon"></ribbon>
    <ribbon v-if="isOpenRedesign && hasActiveStage" :text="content.redesign_card_ribbon"></ribbon>

    <div class="card-body text-center pb-0">
      <h2 class="font-weight-bold card-title mb-0">{{ cardTitle }}</h2>
      <p
        v-if="quote.batteries && quote.batteries.length > 0 && !isGeneric"
        class="with-battery"
        v-html="content.pv_package_with_battery"
      ></p>
      <IconList :items="listItems" :type="'features'" class="mt-6" />
    </div>
    <div class="card-footer text-center pt-0">
      <!--2023-05-20: Temp removed iconlist because backend is not ready -->
      <!-- <IconList :items="checkListItems" :type="'checks'" /> -->
      <!--2023-05-20: Temp removed progress bar because backend is not ready -->
      <!-- <progress-bar
        v-if="!isGeneric"
        :percentage="quote.detailOverview.coverage * 100"
        :contentKey="'pv_package_coverage'"
      ></progress-bar> -->
      <div v-if="quote.detailOverview.contractPriceExclVAT && !trsMode" class="two-price-card">
        <h4 class="font-weight-bold url-blue mb-2">
          {{ quote.detailOverview.contractPrice | formatCurrency }},-
          {{
            $options.filters.replaceDynamicContent(content.pv_topcard_vat)
          }}
        </h4>
        <h4 v-if="!isGeneric" class="mb-6">
          {{ quote.detailOverview.contractPriceExclVAT | formatCurrency }},-
          {{ content.pv_topcard_exc_vat }}
        </h4>
      </div>
      <p v-if="trsMode" class="contractrange col mb-4">
        {{ quote.detailOverview.contractPriceRange.start | formatCurrency }}
        {{ $options.filters.replaceDynamicContent(content.amount_connector) }}
        {{ quote.detailOverview.contractPriceRange.end | formatCurrency }}
      </p>

      <b-button
        v-if="hasActiveStage"
        v-on="{ click: trsMode ? requestOrder : selectOrder }"
        class="mb-4"
        :variant="ctaButtonVariant"
      >
        {{ ctaButtonText }}
      </b-button>

      <p v-if="hasActiveStage" class="detail-link d-flex align-items-center justify-content-center m-0">
        <a class="mr-1" tabindex="-1" v-dynamic-content:pv_package_cta_details></a>
        <chevron-icon></chevron-icon>
      </p>
    </div>
  </fragment>
</template>

<script>
// import ProgressBar from '@/components/main/progress/ProgressBar'
import IconList from '@/components/main/icon-list/IconList'
import Ribbon from '@/components/parts/Ribbon'
import ChevronIcon from '@/components/icons/Chevron'
import { mapGetters } from 'vuex'

export default {
  name: 'Card',
  props: ['quote', 'countOffer'],
  components: {
    Ribbon,
    // ProgressBar,
    IconList,
    ChevronIcon,
  },
  mixins: ['pickProductName'],
  computed: {
    ...mapGetters(['isGeneric', 'isOpenRedesign', 'quoteType']),
    listItems() {
      const items = []
      const { replaceDynamicContent } = this.$options.filters
      const {
        pv_package_inverters_single,
        pv_content_inverter_multiple2,
        pv_content_inverter_multiple3,
        pv_content_inverter_multiple4,
        pv_content_panels,
        pv_content_battery,
      } = this.content

      if (this.isGeneric) {
        const relevantProducts = this.quote.items.filter((i) =>
          ['production meters', 'batteries', 'inverters', 'panels'].includes(
            i.category && i.category.toLowerCase()
          )
        )
        items.push(...relevantProducts.map((i) => `${i.quantity}x  ${this.pickProductName(i)}`))
      } else {
        const { inverters, panels, batteries } = this.quote
        const { quantity } = inverters[0]
        const length = inverters.length
        const batteryText = batteries
          ? batteries.map((b) =>
              replaceDynamicContent(pv_content_battery, [b.quantity, this.pickProductName(b)])
            )
          : []
        items.push(
          replaceDynamicContent(pv_content_panels, [panels.quantity, this.pickProductName(panels)]),
          ...batteryText
        )

        if (length === 1 && quantity === 1)
          items.push(
            replaceDynamicContent(pv_package_inverters_single, [
              quantity,
              this.pickProductName(inverters[0]),
            ])
          )
        if (length === 1 && quantity > 1)
          items.push(
            replaceDynamicContent(pv_content_inverter_multiple2, [
              quantity,
              this.pickProductName(inverters[0]),
            ])
          )
        if (length === 2)
          items.push(
            replaceDynamicContent(pv_content_inverter_multiple3, [
              quantity,
              this.pickProductName(inverters[0]),
              inverters[1].quantity,
              this.pickProductName(inverters[1]),
            ])
          ) // todo: get items via loop?
        if (length === 3)
          items.push(
            replaceDynamicContent(pv_content_inverter_multiple4, [
              quantity,
              this.pickProductName(inverters[0]),
              inverters[1].quantity,
              this.pickProductName(inverters[1]),
              inverters[2].quantity,
              this.pickProductName(inverters[2]),
            ])
          )
      }
      return items
    },
    checkListItems() {
      const { replaceDynamicContent, formatKwh, formatCurrency, formatPercentage, formatAmount } =
        this.$options.filters
      if (this.$store.getters.isGeneric) {
        if (this.quoteType === 'BATTERY') {
          const totalSelfConsumption =
            this.quote.detailOverview.directEnergyUsagePercentage +
            this.quote.detailOverview.batterySelfConsumption
          const items = [
            replaceDynamicContent(this.content.generic_sungevity_usps_battery_usage, [
              formatKwh(this.iquote.energyConsumption),
            ]),
            replaceDynamicContent(this.content.generic_sungevity_usps_battery_capacity, [
              formatKwh(this.quote.detailOverview.batteryCapacity, 1),
            ]),
          ]

          if (this.showBatterySelfConsumption)
            items.push(
              replaceDynamicContent(this.content.generic_sungevity_usps_battery_self_consumption, [
                formatPercentage(totalSelfConsumption),
              ])
            )
          return items
        } else
          return [
            this.content.generic_sungevity_usps_advice,
            this.content.generic_sungevity_usps_installation,
            this.content.generic_sungevity_usps_waranty,
          ]
      } else {
        const {
          energyGenerated,
          annualSavings,
          savingsFirstYear,
          internalRateOfReturn,
          paybackPeriodInYears,
          productionRange,
        } = this.quote.detailOverview
        const {
          pv_package_savingsyear1,
          pv_package_roi,
          pv_package_paybacktime,
          trs_pv_package_production_range,
        } = this.content

        const savings = savingsFirstYear || annualSavings[0]
        const items = [
          replaceDynamicContent(pv_package_savingsyear1, [
            formatKwh(energyGenerated[0]),
            formatCurrency(savings),
          ]),
          replaceDynamicContent(pv_package_roi, [formatPercentage(internalRateOfReturn, 1)]),
        ]

        if (paybackPeriodInYears)
          items.push(
            replaceDynamicContent(pv_package_paybacktime, [formatAmount(paybackPeriodInYears, 1)])
          )
        if (this.trsMode)
          items.push(
            replaceDynamicContent(trs_pv_package_production_range, [
              formatAmount(productionRange.start),
              formatAmount(productionRange.end),
            ])
          )
        return items
      }
    },
    showBatterySelfConsumption() {
      const { batterySelfConsumption, directEnergyUsagePercentage } = this.quote.detailOverview
      return batterySelfConsumption && directEnergyUsagePercentage
    },
    hasActiveStage() {
      return ['sent'].includes(this.quote.stage)
    },
    cardTitle() {
      const { content } = this.$store.getters

      if (this.isOpenRedesign) {
        return this.hasActiveStage
          ? content.redesign_card_new_title
          : content.redesign_card_current_title
      }

      return this.contentFilters(content.pv_package_title, [this.countOffer])
    },
    ctaButtonVariant() {
      return this.isOpenRedesign && this.hasActiveStage ? 'primary' : 'outline-primary'
    },
    ctaButtonText() {
      const { content } = this.$store.getters

      if (this.isOpenRedesign) {
        return this.hasActiveStage
          ? content.redesign_card_new_button
          : content.redesign_card_current_button
      }

      return this.contentFilters(content.pv_package_cta_choose)
    },
    vatPercentageFormatted() {
      return `${this.quote.detailOverview.valueAddedTaxTariffPercentage}%`
    },
  },
  methods: {
    contentFilters(contentKey, filterOptions) {
      return this.$options.filters.replaceDynamicContent(contentKey, filterOptions)
    },
    selectOrder(ev) {
      ev.preventDefault()
      ev.stopPropagation()
      this.$router.push({ name: 'OrderSummary', params: { id: this.quote.id } })
    },
    requestOrder() {
      setTimeout(() => {
        const pos = this.$store.getters.trsCollapsePos
        pos > 0 && this.$store.commit('SET_SCROLL_POSITION', pos)
      }, 100)
    },
  },
}
</script>

<style scoped>
.with-battery {
  font-size: 20px;
  color: #00609c;
}
</style>
